import React from 'react';
import { PawPrint } from 'lucide-react';
import { useStore } from '../store';

// Small on-screen "name card" the Harpy Eagle shows on an animal fly-by.
export default function FieldCard() {
  const fieldCard = useStore((s) => s.fieldCard);
  if (!fieldCard) return null;
  return (
    <div
      data-testid="field-guide-card"
      className="absolute bottom-64 left-1/2 -translate-x-1/2 z-[60] w-full max-w-sm px-4 pointer-events-none"
    >
      <div className="glass-gold rounded-2xl px-5 py-3.5 flex items-center gap-4 border border-gold/40 animate-hud-in">
        <div className="shrink-0 w-11 h-11 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center">
          <PawPrint className="w-6 h-6 text-gold" strokeWidth={1.6} />
        </div>
        <div className="min-w-0">
          <div className="font-mono text-[9px] uppercase tracking-[0.3em] text-gold/70">Field Guide · Species</div>
          <div data-testid="field-guide-name" className="font-serif text-xl text-white leading-tight truncate">{fieldCard.name}</div>
        </div>
      </div>
    </div>
  );
}
